export default __webpack_public_path__ + "static/events-hero-1-8024508a1ec22a138dd194ec795d0e42.jpg";